import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { CF_ADMIN_ROLE_ID, PQ_ADMIN_ROLE_ID } from '../../../../../lib/appConstants';
import * as commonActions from '../../../../common/actions';
import * as actions from './actions';
import DocumentRules from './tabs/DocumentRules';
import SystemIntegrations from './tabs/SystemIntegrations';
import { ToastContainer } from 'react-toastify';
import './holderSettings.css';
import DocumentTypes from '../document-types';
import HolderRegistrationSettings from "../registration";
import RolAccess from '../../../../common/rolAccess';

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'documentRules',
    };
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;
    const haveTabPermission = this.props.login.profile.CFRole.Id === CF_ADMIN_ROLE_ID || this.props.login.profile.Role.Id === PQ_ADMIN_ROLE_ID;
    const { holderId, holderArchived } = this.props;
    return (
      <>
        {
          haveTabPermission ?
            (
              <div className="holder-settings">
                <div className="nav-tab-header" style={{ display: 'flex', borderBottom: '1px solid #ddd', marginBottom: '15px' }}>
                  <button
                    className={`nav-btn ${activeTab === 'documentRules' ? 'active' : ''}`}
                    onClick={() => this.handleTabChange('documentRules')}
                  >
                    Document Rules
                  </button>
                  <button
                    className={`nav-btn ${activeTab === 'systemIntegrations' ? 'active' : ''}`}
                    onClick={() => this.handleTabChange('systemIntegrations')}
                  >
                    System Integrations
                  </button>
                  <RolAccess
                    masterTab="document_types"
                    sectionTab="view_tab"
                    component={() => (
                      <button
                        className={`nav-btn ${activeTab === 'documentTypes' ? 'active' : ''}`}
                        onClick={() => this.handleTabChange('documentTypes')}
                      >
                        Document Types
                      </button>
                    )}
                  />
                  <RolAccess
                    masterTab="holder_settings"
                    sectionTab="view_tab"
                    component={() => (
                      <button
                        className={`nav-btn ${activeTab === 'registration' ? 'active' : ''}`}
                        onClick={() => this.handleTabChange('registration')}
                      >
                        Registration
                      </button>
                    )}
                  />
                </div>
                <div className="tab-content">
                  {activeTab === 'documentRules' && <DocumentRules {...this.props} />}
                  {activeTab === 'systemIntegrations' && <SystemIntegrations holderId={holderId} />}
                  {activeTab === 'documentTypes' && (
                    <RolAccess
                      masterTab="document_types"
                      sectionTab="view_tab"
                      component={() => (
                        <DocumentTypes 
                          holderId={holderId}
                          holderArchived={holderArchived} 
                        />
                      )}
                    />
                  )}
                  {activeTab === 'registration' && (
                    <RolAccess
                      masterTab="holder_settings"
                      sectionTab="view_tab"
                      component={() => (
                        <HolderRegistrationSettings
                          holderId={holderId}
                          holderArchived={holderArchived}
                        />
                      )}
                    />
                  )}
                </div>
                <ToastContainer />
              </div>
            ) : (
              <DocumentRules {...this.props} />
            )
        }
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    holderSettings: state.holderSettings,
    local: state.localization,
    common: state.common,
    login: state.login,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));
